import {receptionBunkersStore, transportStore} from "../index";


export default class ReceptionDispathcer{
    static addTransportToBunkerStack(bunkerId,stackPosition,removeTransportId){
        receptionBunkersStore.receptionBunker[bunkerId].addToStack(
            stackPosition,
            transportStore.receptionTruck[removeTransportId]
        );
        transportStore.removeTransport(removeTransportId)
    }

    static switchStack(bunkerId,stackPosition,removeTransportId){
        receptionBunkersStore.receptionBunker[bunkerId].addToStack(removeTransportId.bunkerId === bunkerId && removeTransportId.num < stackPosition  ? stackPosition+1 : stackPosition,receptionBunkersStore.receptionBunker[removeTransportId.bunkerId].transportStack[removeTransportId.num]);
        receptionBunkersStore.receptionBunker[removeTransportId.bunkerId].removeTransportFromStack(removeTransportId.bunkerId === bunkerId && removeTransportId.num > stackPosition  ? removeTransportId.num +1 : removeTransportId.num);
    }

    static returnTransportFromBunkerStack(bunkerId,num){
        transportStore.addTransport(receptionBunkersStore.receptionBunker[bunkerId].transportStack[num]);
        receptionBunkersStore.receptionBunker[bunkerId].removeTransportFromStack(num)
    }
}


// WEBPACK FOOTER //
// ./src/shared/stores/Dispatcher/ReceptionDispathcer.js